import type { FC, ReactElement } from "react";

interface LoaderWrapperProps {
  children: ReactElement | ReactElement[];
}

const LoaderWrapper: FC<LoaderWrapperProps> = ({ children }) => {
  return (
    <div className="fixed inset-0 z-50 bg-[#00000066] flex items-center justify-center animate-fade-in">
      {children}
    </div>
  );
};

export default LoaderWrapper;
